import { DataGrid } from "devextreme-react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionClaimList, resetClaimList } from "../store";
import ListDateFilters from "../../../../../component/filters/list_date_filters";
import ListCalendarFilter from "../../../../../component/filters/list_calendar_filter";
import {
  actionDownload,
  resetDownloadPolicyResponse,
} from "../../dashboard/store";
import {
  Column,
  Export,
  HeaderFilter,
  Search,
  SearchPanel,
  Button,
  FilterRow,
} from "devextreme-react/cjs/data-grid";
import {
  TOAST_DURATION,
  TOAST_ERROR_COLOR,
  TOAST_POSITION,
} from "../../../../../common/app_constant";
import toast from "react-hot-toast";
import { getLocalStorageItem, onExporting } from "../../../../../utils";
import moment from "moment";
import BulkUpload from "../../../../../component/bulk_upload";
import { useNavigate } from "react-router-dom";
import Loader from '../../../../../component/page_loader';

const ClaimList = () => {
  const [viewClaimList, setViewClaimList] = useState();
  const [uploadBulk, setUploadBulk] = useState(false);
  const [role, setRole] = useState();
  const [isLoader, setIsLoader] = useState(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { ClaimList } = useSelector((state) => ({
    ...state.listStore,
  }));

  const { downloadPolicy } = useSelector((state) => ({
    ...state.dashboardStore,
  }));

  const updateFromDate = (newFromDate) => {
    setFromDate(newFromDate);
  };

  const updateToDate = (newToDate) => {
    setToDate(newToDate);
  };

  const finalFromDate = (newFromDate) => {
    fromDate(newFromDate);
  };

  const finalToDate = (newToDate) => {
    toDate(newToDate);
  };

  const handleResetClick = () => {
    setFromDate(initialFromDate);
    setToDate(initialToDate);
  };

  const initialFromDate = ''
  // moment(new Date())
  // .subtract(2, "month")
  // .format("YYYY-MM-DD");
  const initialToDate = ''
  // moment(new Date())
  // .add(4, "month").format("YYYY-MM-DD");

  const [fromDate, setFromDate] = useState(initialFromDate);
  const [toDate, setToDate] = useState(initialToDate);

  useEffect(() => {
    setRole(getLocalStorageItem("next"));
    // dispatch(actionClaimList());
  }, []);

  useEffect(() => {
    if (role == 'copsdashboard') {
      dispatch(
        actionClaimList({
          dynamic_url: 'admin/claim/list',
          from_date: fromDate,
          to_date: toDate,
        })
      );
    } else if (role == 'employerdashboard' || role == "superuserdashboard" ) {
      dispatch(
        actionClaimList({
          dynamic_url: 'employer/claim-list',
          from_date: fromDate,
          to_date: toDate,
        }))
    }
  }, [role]);

  useEffect(() => {
    dispatch(resetClaimList());
    if (ClaimList != null) {
      if (ClaimList.status == true) {
        setIsLoader(false);
        setViewClaimList(ClaimList.data);
      } else {
        setIsLoader(false);
        switch (ClaimList.status_code) {
          case 400:
            toast.error(ClaimList.message, {
              duration: TOAST_DURATION,
              position: TOAST_POSITION,
              style: {
                color: TOAST_ERROR_COLOR,
              },
            });
            localStorage.clear();
            navigate("/login", { replace: true });
            break;
          case 401:
            localStorage.clear();
            navigate("/login", { replace: true });
            break;
          default:
        }
      }
    }
  });

  const renderDateCell = (date) => {
    const formattedDate = date
      ? moment(date).isValid()
        ? moment(date).format("DD-MMM-YYYY")
        : "-"
      : "";
    return formattedDate;
  };

  const renderAmountFixed = (data) => {
    const amountFormat = data ? Number(data).toFixed(2) : "-";
    return amountFormat;
  };

  const onDownloadDocumentClick = (event) => {
    if (event && event.row && event.row.data) {
      const { dmsIds } = event.row.data;
      console.log(dmsIds);
      if (!!dmsIds) {
        dispatch(actionDownload(dmsIds));
      }
    }
  };
  const rendercapitalizeData = (value) => {
    const captitalize = value
      ? value.charAt(0).toUpperCase() + value.slice(1)
      : "-";
    return captitalize;
  };

  const renderAction = (data) => (
    <>
      {role == "copsdashboard" && (
        <button
          className={`btn btn-sm btn-primary cursor-pointer`}
          onClick={() => {
            if (data) {
              console.log(JSON.stringify(data));
              navigate("/employer/claims/update", { state: { data: data } });
            }
          }}
        >
          Edit
        </button>
      )}
      <button
        className={`btn btn-sm btn-primary cursor-pointer mx-1`}
        onClick={() => {
          if (data) {
            navigate("/employer/claims/details", { state: { data: data } });
          }
        }}
      >
        View
      </button>
    </>
  );

  useEffect(() => {
    if (downloadPolicy !== null) {
      dispatch(resetDownloadPolicyResponse());
      if (downloadPolicy.status === true) {
        window.open(downloadPolicy.data.url);
      } else {
        switch (downloadPolicy.status_code) {
          case 400:
            toast.error(downloadPolicy.message, {
              duration: TOAST_DURATION,
              position: TOAST_POSITION,
              style: {
                color: TOAST_ERROR_COLOR,
              },
            });
            localStorage.clear();
            navigate("/login");
            break;
          case 401:
            localStorage.clear();
            navigate("/login", { replace: true });
            break;
          default:
        }
      }
    }
  }, [downloadPolicy]);

  // api call on date change START
  useEffect(() => {
    if (role == "copsdashboard" ) {
      dispatch(
        actionClaimList({
          dynamic_url: "admin/claim/list",
          from_date: fromDate,
          to_date: toDate,
        })
      );
    } else if (role == 'employerdashboard' || role == "superuserdashboard") {
      dispatch(
        actionClaimList({
          dynamic_url: "employer/claim-list",
          from_date: fromDate,
          to_date: toDate,
        })
      );
    }
    // dispatch(
    //   actionClaimList({
    //     from_date: fromDate,
    //     to_date: toDate,
    //     page: 1,
    //     size: 500,
    //     endorsement: "set",
    //   })
    // );
  }, [toDate, fromDate]);
  // api call on date change END

  const renderConcatinatedCell = (data) => {
    const formattedString = data?.policy_detail?.vehicle_make && data?.policy_detail?.vehicle_model ?
      data?.policy_detail?.vehicle_make + ' - ' + data?.policy_detail?.vehicle_model
      : "-";
    return formattedString;
  };
  return (
    <>
      <div className="row  justify-content-center pb-5 mt-6">
        <div className="col-12 mb-5">
          <div className="d-flex justify-content-between mb-2">
            <div className="">
              <h5 className="mb-0">Claim List</h5>
            </div>
            <div className="">
              {/* {role == "copsdashboard" && ( */}
              <>
                <button
                  className={`btn btn-sm btn-primary cursor-pointer me-2`}
                  onClick={() => {
                    navigate("/employer/claims/update");
                  }}
                >
                  Add
                </button>
                <button
                  className={`btn btn-sm btn-primary cursor-pointer `}
                  onClick={() => {
                    setUploadBulk(true);
                  }}
                >
                  Add Bulk
                </button>
              </>
              {/* )} */}
            </div>
          </div>
          {/* renewal date filter */}
          <ListDateFilters
            lebel1={"Claim Date From"}
            lebel2={"Claim Date To"}
            updateFromDate={updateFromDate}
            updateToDate={updateToDate}
            resetClick={handleResetClick}
            fromDate={fromDate}
            toDate={toDate}
          />

          {isLoader === true ? (
            <Loader />
          ) : (
            <div className="card border mt-3">
              <div className="card-header">
                {/* calender filter component */}
                <ListCalendarFilter
                  updateFromDate={updateFromDate}
                  updateToDate={updateToDate}
                  finalFromDate={finalFromDate}
                  finalToDate={finalToDate}
                />
              </div>
              <div className="card-body">
                <DataGrid
                  id="claim_list"
                  dataSource={viewClaimList}
                  columnMinWidth={100}
                  showBorders={true}
                  filterSyncEnabled={false}
                  allowColumnResizing={true}
                  columnAutoWidth={true}
                  onExporting={onExporting}
                >
                  <FilterRow visible={true} />
                  <HeaderFilter visible={true} />
                  <SearchPanel visible={true} />
                  {/* {role == "copsdashboard" && ( */}
                  <Column
                    dataField="action"
                    cellRender={({ data }) => renderAction(data)}
                    caption="Action"
                  ></Column>
                  {/* )} */}

                  <Column
                    dataField="index"
                    caption="S.No"
                    dataType="number"
                    cellRender={(rowData) => {
                      return rowData?.rowIndex != null
                        ? Number(rowData?.rowIndex + 1)
                        : "-";
                    }}
                  />
                  <Column dataField="policy_detail.insured_name" caption="Full Name " />
                  <Column
                    dataField="policy_detail.userDetails.mobile"
                    caption="Employee Mobile Number"
                    dataType="string"
                  />
                  <Column
                    dataField="policy_detail.userDetails.email"
                    caption="Employee Email ID "
                  />
                  <Column
                    dataField="insurer_claim_no"
                    caption="Claim Number "
                    dataType="number"
                  />
                  <Column
                    dataField="policy_detail.policy_no"
                    caption="Policy Number  "
                  />
                  <Column
                    dataField="policy_detail.insurer_name"
                    caption="Insurer Name"
                  />
                  <Column
                    dataField="policy_detail.vehicle_no"
                    caption="Vehicle Number"
                  />
                  <Column
                    dataField="claim_type"
                    caption="Claim Type"
                    cellRender={({ value }) => rendercapitalizeData(value)}
                  />
                  <Column dataField="status" caption="Claim Status" />
                  <Column
                    dataField="amount"
                    caption="Claimed Amount"
                    dataType="number"
                    cellRender={({ value }) => renderAmountFixed(value)}
                  />
                  <Column
                    dataField="settlement_amount"
                    caption="Settled Amount"
                    dataType="number"
                    cellRender={({ value }) => renderAmountFixed(value)}
                  />
                  <Column
                    dataField="claim_closed_date"
                    caption="Claim Close Date"
                    dataType="date"
                    cellRender={({ value }) => renderDateCell(value)}
                  />
                  <Column
                    dataField="vehicle_make_model"
                    caption="Vehicle Make & Model "
                    cellRender={({ data }) => renderConcatinatedCell(data)}
                  />
                  <Column
                    dataField="policy_detail.policy_type"
                    caption="Policy Type"
                  />
                  <Column
                    dataField="policy_detail.policy_expiry_date"
                    caption="Policy Due Date   "
                    dataType="date"
                    cellRender={({ value }) => renderDateCell(value)}
                  />
                  <Column
                    dataField="dmsIds"
                    type="buttons"
                    width={100}
                    caption="Download Claim"
                  >
                    <Button
                      onClick={onDownloadDocumentClick}
                      name="downloadPolicy"
                      icon="download"
                    />
                  </Column>
                  <Export enabled={true} />
                </DataGrid>
              </div>
            </div>
          )}
        </div>
      </div>
      <BulkUpload
        show={uploadBulk}
        module="claim"
        dynamic_url="importclaims"
        handleUpdateList={() => {
          setUploadBulk(false);
          // dispatch(actionClaimList());
          if (role == 'copsdashboard') {
            dispatch(
              actionClaimList({
                dynamic_url: 'admin/claim/list',
                from_date: fromDate,
                to_date: toDate,
              })
            );
          } else if (role == 'employerdashboard' || role == "superuserdashboard") {
            dispatch(
              actionClaimList({
                dynamic_url: 'employer/claim-list',
                from_date: fromDate,
                to_date: toDate,
              }))
          }
        }}
      />
    </>
  );
};
export default ClaimList;
